// must match TurnstileService.Actions in java/cloud/turnstile — the backend
// rejects tokens whose action does not match the endpoint's expected action
export const TurnstileAction = {
    CUSTOMER_LOGIN: 'customer-login',
    CUSTOMER_SIGNUP: 'customer-signup',
    CUSTOMER_FORGOT_PASSWORD: 'customer-forgot-password',
    CUSTOMER_LOGIN_CREATE: 'customer-login-create',
    CUSTOMER_LOGIN_UPDATE: 'customer-login-update',
    CUSTOMER_UNCONFIRMED_EMAIL: 'customer-unconfirmed-email',
    CUSTOMER_EMAIL_CHANGE: 'customer-email-change',
    OPERATOR_LOGIN: 'operator-login',
    OPERATOR_RESET_PASSWORD: 'operator-reset-password',
} as const;
